module.exports = __webpack_public_path__ + "img/image 28@2x.5bf15adf.png";